module.exports = __webpack_public_path__ + "img/19.9f9b9521.png";